import { ChangeEvent } from "react";
import { ID_NUMBER_LENGTH, UserForm, UserFormErrors } from "./userForm";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export type UserTextChangeEvent = ChangeEvent<
  HTMLInputElement | HTMLTextAreaElement
>;

const PHONE_MAX_LENGTH = 10;

interface SalesStaffFieldsProps {
  form: UserForm;
  errors: UserFormErrors;
  onTextChange: (field: keyof UserForm) => (event: UserTextChangeEvent) => void;
}

/** The staff row a sales person needs — saved together with the account in the same request. */
export default function SalesStaffFields({
  form,
  errors,
  onTextChange,
}: SalesStaffFieldsProps) {
  return (
    <Stack gap={2}>
      <Typography variant="body2" fontWeight={500}>
        ข้อมูลพนักงานขาย
      </Typography>
      <TextField
        label="ชื่อ-นามสกุลพนักงาน"
        value={form.full_name}
        onChange={onTextChange("full_name")}
        error={Boolean(errors.full_name)}
        helperText={errors.full_name}
        size="small"
        required
      />
      <TextField
        label="เลขบัตรประชาชน"
        value={form.id_number}
        onChange={onTextChange("id_number")}
        error={Boolean(errors.id_number)}
        helperText={errors.id_number}
        size="small"
        required
        slotProps={{
          htmlInput: { maxLength: ID_NUMBER_LENGTH, inputMode: "numeric" },
        }}
      />
      <TextField
        label="เบอร์โทร"
        value={form.phone}
        onChange={onTextChange("phone")}
        error={Boolean(errors.phone)}
        helperText={errors.phone}
        size="small"
        slotProps={{
          htmlInput: { maxLength: PHONE_MAX_LENGTH, inputMode: "tel" },
        }}
      />
    </Stack>
  );
}
